import { render, staticRenderFns } from "./CommonMask.vue?vue&type=template&id=4f16ea2c&scoped=true"
import script from "./CommonMask.vue?vue&type=script&lang=js"
export * from "./CommonMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f16ea2c",
  null
  
)

export default component.exports